import {
  AddOutlined,
  ArrowBackOutlined,
  DeleteOutline,
  EditOutlined,
  RefreshOutlined,
} from "@material-ui/icons";
import {
  Box,
  Button,
  CardHeader,
  Grid,
  IconButton,
  LinearProgress,
  Paper,
  TextField,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { frFR } from "@mui/x-data-grid/locales";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import SearchIcon from "@mui/icons-material/Search";
import useToast from "../../../../../../hooks/useToast";
import useConfirm from "../../../../../../hooks/useConfirm";
import SQCDialogForm from "./SQCDialogForm";
import { useQuery } from "../../../../../../hooks/useQuery";
import { TYPE_NOTIFICATION } from "../../../../shares/NotificationBull";
import { DomaineParAMIService } from "../../../../../../service/DomaineParAMIService";
import AssignerDomaineList from "./AssignerDomaineList";

const DomaineParTypeList = ({ selection = false }) => {
  const [formulaireList, setFormulaireList] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const navigate = useNavigate();
  const [filtre, setFiltre] = useState({});
  const { Toast, showToast } = useToast();
  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [idSelectedForm, setIdSelectedForm] = useState(null);
  const { DialogComponent, openConfirmDialog } = useConfirm();
  const url = useQuery();
  const id_type = url.get("ref");

  const handleGoBack = () => {
    navigate(-1);
  };
  const handleFetchDomaineList = () => {
    setDataLoading(true);
    DomaineParAMIService.lister({ ...filtre, id_type: url.get("ref") })
      .then((res) => {
        if (res && res.data) {
          setFormulaireList(res.data);
          setFilteredRows(res.data);
        } else {
          setFormulaireList([]);
          setFilteredRows([]);
        }
      })
      .finally(() => {
        setDataLoading(false);
      });
  };

  const handleDeleteRow = (row) => {
    openConfirmDialog(
      "Confirmation",
      "Voullez vous supprimer cette ligne?",
      () => {
        handleConfirmDeleteRow(row);
      }
    );
  };

  const handleConfirmDeleteRow = (row) => {
    DomaineParAMIService.delete(row).then((res) => {
      if (res && res.success) {
        showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
        handleFetchDomaineList();
      } else {
        showToast(TYPE_NOTIFICATION.ERROR, res.message);
      }
    });
  };

  const handleOpenDialogForm = (idForm) => {
    setOpenFormDialog(true);
    //setIdSelectedForm(idForm);
  };

  const handleCloseDialogForm = () => {
    setOpenFormDialog(false);
    handleFetchDomaineList();
  };

  const handleFilter = (filtre) => {
    if (!filtre || String(filtre).trim() === "") {
      setFilteredRows(formulaireList);
      return;
    }
    const mots = filtre
      .toLowerCase()
      .split(" ")
      .filter((mot) => mot.trim() !== "");
    setFilteredRows(
      formulaireList.filter((item) =>
        mots.every((mot) =>
          Object.values(item).some(
            (val) => val && val.toString().toLowerCase().includes(mot)
          )
        )
      )
    );
  };

  const handleShowQuestionList = (dom_id) => {
    navigate(`sous-domaine?ref=${url.get("ref")}&dom=${dom_id}`);
  };

  const table_colonne = [
    {
      field: "name",
      headerName: "Domaine",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "description",
      headerName: "Description du domaine",
      flex: 1,
      minWidth: 200,
    },
    {
      // field: "created_at",
      field: "created_at",
      headerName: "Date de création",
      minWidth: 180,
    },
    {
      field: "updated_at",
      headerName: "Date de modification",
      minWidth: 180,
    },
    {
      field: "action",
      headerName: "Actions",
      minWidth: 180,
      renderCell: (params) => {
        return (
          <Grid>
            <IconButton
              title="Parametrer sous domaine"
              color="primary"
              onClick={(e) => handleShowQuestionList(params.row.id_domaine)}
            >
              <SettingsOutlinedIcon />
            </IconButton>
            {/* <IconButton
              title="Modifier formulaire"
              color="secondary"
              // onClick={(e) => handleOpenDialogForm(params.row.ext_sqc_form_id)}
            >
              <EditOutlined />
            </IconButton> */}
            <IconButton
              title="Supprimer formulaire"
              color="warning"
              onClick={(e) => handleDeleteRow(params.row)}
            >
              <DeleteOutline />
            </IconButton>
          </Grid>
        );
      },
    },
  ];

  useEffect(() => {
    handleFetchDomaineList();
  }, []);

  return (
    <>
      <AssignerDomaineList
        open={openFormDialog}
        onFormClose={(e) => handleCloseDialogForm()}
      />
      <DialogComponent />
      <Toast />
      <Grid width={"100%"}>
        <Paper elevation={0}>
          <Grid>
            <CardHeader
              title="Les domaines liés à l'AMI"
              titleTypographyProps={{ variant: "h5" }}
              avatar={
                <Button onClick={handleGoBack}>
                  <ArrowBackOutlined />
                </Button>
              }
              action={
                <Grid container spacing={2} justifyContent="space-around">
                  <Grid item>
                    <TextField
                      id="recherche"
                      fullWidth
                      size="small"
                      onChange={(e) => handleFilter(e.target.value)}
                      placeholder="Recherche"
                      InputProps={{
                        endAdornment: (
                          <IconButton>
                            <SearchIcon />
                          </IconButton>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <IconButton
                      title="Actualiser"
                      color="primary"
                      onClick={handleFetchDomaineList}
                    >
                      <RefreshOutlined />
                    </IconButton>
                  </Grid>
                  <Grid item>
                    <IconButton
                      onClick={(e) => handleOpenDialogForm(null)}
                      color="primary"
                      title="Creer une formulaire"
                    >
                      <AddOutlined />
                    </IconButton>
                  </Grid>
                </Grid>
              }
            />
            <Grid container>
              <Box display={dataLoading ? "" : "none"} sx={{ width: "100%" }}>
                <LinearProgress />
              </Box>
              <DataGrid
                sx={{
                  width: {
                    xs: "75.5vw",
                    sm: "90vw",
                    md: "93.5vw",
                    lg: "79.5vw",
                    height: "60vh",
                  },
                }}
                columns={table_colonne}
                // rows={formulaireList}
                rows={filteredRows}
                getRowId={(row) => row.id_domaine_type}
                localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
              />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </>
  );
};

export default DomaineParTypeList;
